// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".hamburgerMenu{cursor:pointer;display:none}.hamburgerMenu--bordered{border:1px solid #e6e6e6;border-radius:4px;padding:1rem 2.5rem}@media(max-width:1366px){.hamburgerMenu{align-items:center;display:flex}}.hamburgerMenu__icon span{background-color:#582c83;display:block;height:2px;margin:4px 0;width:20px}.hamburgerMenu__text{color:#575766;font-size:1.4rem;font-weight:600;line-height:1.8rem;margin-left:1rem}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
